import { render, staticRenderFns } from "./editcompany.vue?vue&type=template&id=3a8b40e2&"
import script from "./editcompany.vue?vue&type=script&lang=js&"
export * from "./editcompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports